export default __webpack_public_path__ + "static/Montserrat-Light-6fcc9263a21be961d246698e697820e9.ttf";